import { React, useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Button from "@mui/material/Button";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
} from "@mui/material";
import DataTable from "examples/Tables/DataTable";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { Divider, Dropdown } from "semantic-ui-react";
import { ToastContainer, toast } from "react-toastify";
import { Stack } from "@mui/material";
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import Papa from "papaparse";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import MDBadge from "components/MDBadge";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useNavigate } from "react-router-dom";
import PrintIcon from "@mui/icons-material/Print";
import VisibilityIcon from "@mui/icons-material/Visibility";
import colors from "assets/theme/base/colors";
import "../campus/Campus.css";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import Select from "react-select";
import VoucherDialog from "views/pages/student_dashboard/Pages/VoucherDialog";
const { info } = colors;
const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");
import nodata from "assets/images/nodata.png";
const ITEM_HEIGHT = 50;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const primaryButtonStyle = {
  color: "white",
  backgroundColor: "#28166f",
};

const campaignSelectStyles = {
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
};

function TestResultEntry() {
  //Dialog Settings
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const navigate = useNavigate();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [maxWidth, setMaxWidth] = useState("xl");
  const [genderFilter, setGenderFilter] = useState("");
  const [nationalityFilter, setNationalityFilter] = useState("");
  const nationalities = ["Pakistani", "Overseas"];
  const [editingRow, setEditingRow] = useState(null);
  const [marks, setMarks] = useState({});
  const [proposalMarks, setProposalMarks] = useState({});
  const [publicationMarks, setPublicationMarks] = useState({});
  const userDepartment = JSON.parse(sessionStorage.getItem("department_id"))
  //Session Storage Rendering
  var user = JSON.parse(sessionStorage.getItem("user"));
  if (user) {
    var organization_id = user.organization_id;
  } else {
    var organization_id = null;
  }

  const [anchorEl, setAnchorEl] = useState(null);
  const [opens, setOpens] = useState(false);
  const [currentAppId, setCurrentAppId] = useState(null);

  const handleClick = (event, appId) => {
    setAnchorEl(event.currentTarget);
    setOpens(true);
    setCurrentAppId(appId);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpens(false);
    setCurrentAppId(null);
  };

  const handlePrint = () => {
    window.open(`/test-slip/${currentAppId}/`);
  };

  const handleViewApplication = () => {
    navigate(`/view-application/${currentAppId}/`);
  };

  //Variable Declarations
  const [all_applications, setAllApplications] = useState([]);
  const [all_campaigns, setAllCampaigns] = useState([]);
  const [all_campuses, setAllCampuses] = useState([]);
  const [all_departments, setAllDepartments] = useState([]);
  const [all_degrees, setAllDegrees] = useState([]);
  const [all_quotas, setAllQuotas] = useState([]);
  const [campaign_id, setCampaignId] = useState([]);
  const [campus_id, setCampusId] = useState([]);
  const [department_id, setDepartmentId] = useState([]);
  const [degree_id, setDegreeId] = useState([]);
  const [quota_id, setQuotaId] = useState([]);
  const [originalApplications, setOriginalApplications] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [extraVoucherModalOpen, setExtraVoucherModalOpen] = useState(false);
  const [voucherPrintModal, setVoucherPrintModal] = useState(false);
  const [voucherPrintData, setVoucherPrintData] = useState({});
  const [extraVoucherSubmitting, setExtraVoucherSubmitting] = useState(false);
  const [fetchingApplicationDetails, setFetchingApplicationDetails] = useState(false);
  const [extraVoucherForm, setExtraVoucherForm] = useState({
    due_date: "",
    fee: "1000",
    form_no: "",
    campaign_id: "",
    label: "Extra Test Voucher",
  });
  const [extraVoucherApplication, setExtraVoucherApplication] = useState(null);
  const [existingExtraVoucher, setExistingExtraVoucher] = useState(null);
  const [existingVoucherPrintData, setExistingVoucherPrintData] = useState(null);

  const handleSearchKeywordChange = (e) => {
    const searchTerm = e.target.value.trim().toLowerCase();
    setSearchKeyword(searchTerm);
    filterApplications(searchTerm, genderFilter, nationalityFilter); // Filter immediately on search change
  };

  const handleGenderFilterChange = (e) => {
    const selectedGender = e.target.value;
    setGenderFilter(selectedGender);
    filterApplications(searchKeyword, selectedGender, nationalityFilter); // Filter immediately on gender change
  };

  const handleNationalityFilterChange = (e) => {
    const selectedNationality = e.target.value;
    setNationalityFilter(selectedNationality);
    filterApplications(searchKeyword, genderFilter, selectedNationality); // Filter immediately on nationality change
  };

  const filterApplications = (
    searchTerm,
    selectedGender,
    selectedNationality
  ) => {
    let filteredApplications = originalApplications.filter((app) => {
      const idMatch =
        app.id && app.id.toString().toLowerCase().includes(searchTerm);
      const applicantFirstNameMatch =
        app.name && app.name.toLowerCase().includes(searchTerm);

      return (
        (idMatch ||
          applicantFirstNameMatch)
      );
    });

    // Update the state with the filtered applications
    setAllApplications(filteredApplications);
  };

  const handleFocus = (e) => {
    const { name } = e.target;

    setFormErrors((prevFormErrors) => ({
      ...prevFormErrors,
      [name]: "",
    }));
  };

  // Check if the selected degree is a Doctorate program
  const isDoctorateProgram = (app) => {
  return ["PH.D", "Phd-5"].includes(app.application_type);
};

  const columns = [
    { Header: "Sr.No", accessor: "serial", align: "Center" },
    { Header: "Application ID", accessor: "id", align: "center" },
    { Header: "Applicant Name", accessor: "applicant_name", align: "center" },
    { Header: "Father Name", accessor: "father_name", align: "center" },
    { Header: "DOB", accessor: "dob", align: "center" },
    { Header: "Gender", accessor: "gender", align: "center" },
    { Header: "Test Name", accessor: "test_name", align: "center" },
    { Header: "Total Marks", accessor: "total_marks", align: "center" },
    { Header: "Obtained Marks", accessor: "marks", align: "center" },
    // Conditional columns for Doctorate programs
    ...(all_applications.length > 0 && isDoctorateProgram(all_applications[0]) ? [
      { Header: "Proposal Topic", accessor: "proposal_topic", align: "center" },
      { Header: "Proposal Marks (/10)", accessor: "proposal_marks", align: "center" },
      { Header: "Publication Marks (/10)", accessor: "publication_marks", align: "center" }
    ] : []),
    { Header: "Actions", accessor: "actions", align: "center" },
  ];

  const rows =
    all_applications.length > 0
      ? all_applications.map((app, index) => {
        const isEditing = editingRow === app.id;
        const showActions = app.test_name === "University Test" && app.test_required === "yes";
        const isDoctorateProg = isDoctorateProgram(app);

        const baseRow = {
          serial: index + 1,
          id: app.id,
          applicant_name: app.name,
          father_name: app.father_name,
          dob: app.dob,
          gender: app.gender,
          test_name: app.test_name,
          total_marks: (app.test_marks === null || app.test_marks === "") ? "100" : app.total_marks,
          marks: isEditing ? (
            <TextField
              value={marks[app.id] || ""}
              onChange={(e) => handleMarksChange(app.id, e.target.value)}
              size="small"
            />
          ) : (
            (app.test_marks === null || app.test_marks === "") ? (
              app.entry_test_marks
            ) : (
              app.test_marks
            )
          ),
        };

        // Add doctorate-specific columns if applicable
        if (isDoctorateProg) {
          baseRow.proposal_topic = app.proposal_topic || "N/A";
          baseRow.proposal_marks = isEditing ? (
            <TextField
              value={proposalMarks[app.id] || ""}
              onChange={(e) => handleProposalMarksChange(app.id, e.target.value)}
              size="small"
              type="number"
              inputProps={{ min: 0, max: 10 }}
              placeholder="0-10"
            />
          ) : (
            app.proposal_marks || "0"
          );
          baseRow.publication_marks = isEditing ? (
            <TextField
              value={publicationMarks[app.id] || ""}
              onChange={(e) => handlePublicationMarksChange(app.id, e.target.value)}
              size="small"
              type="number"
              inputProps={{ min: 0, max: 10 }}
              placeholder="0-10"
            />
          ) : (
            app.publication_marks || "0"
          );
        }

        baseRow.actions = showActions ? (
          isEditing ? (
            <IconButton onClick={() => handleSaveMarks(app.id)}>
              <SaveIcon style={{ color: "green" }} />
            </IconButton>
          ) : (
            <IconButton onClick={() => handleEditMarks(app.id)}>
              <EditIcon style={{ color: "blue" }} />
            </IconButton>
          )
        ) : null;

        return baseRow;
      })
      : [
        {
          serial: null,
          id: null,
          applicant_name: null,
          father_name: null,
          campaign_name: null,
          campus_name: null,
          department_name: null,
          degree_name: null,
          status: null,
          actions: null,
        },
      ];

  const handleEditMarks = (rowId) => {
    setEditingRow(rowId); // Set the row in editing mode
    setMarks((prev) => ({ ...prev, [rowId]: marks[rowId] || "" })); // Initialize the marks if not set
    setProposalMarks((prev) => ({ ...prev, [rowId]: proposalMarks[rowId] || "" }));
    setPublicationMarks((prev) => ({ ...prev, [rowId]: publicationMarks[rowId] || "" }));
  };

  const handleMarksChange = (rowId, value) => {
    setMarks((prev) => ({ ...prev, [rowId]: value })); // Update marks locally
  };

  const handleProposalMarksChange = (rowId, value) => {
    if (value >= 0 && value <= 10) {
      setProposalMarks((prev) => ({ ...prev, [rowId]: value }));
    }
  };

  const handlePublicationMarksChange = (rowId, value) => {
    if (value >= 0 && value <= 10) {
      setPublicationMarks((prev) => ({ ...prev, [rowId]: value }));
    }
  };

  const handleSaveMarks = async (rowId) => {
    let data = {
      application_id: rowId,
      program_id: degree_id,
      obtained_test_score: marks[rowId]
    };

    // Add doctorate-specific fields if applicable
    const app = all_applications.find(a => a.id === rowId);
    if (isDoctorateProgram(app)) {
      data.proposal_marks = proposalMarks[rowId] || 0;
      data.publication_marks = publicationMarks[rowId] || 0;
    }

    console.log(data);
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    };
    await fetch(
      `${BASE_URL}/application/edit_test_result`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
      })
      .catch((error) => {
        console.error(error);
      });
    if (marks[rowId] === null) {
      setMarks((prev) => ({ ...prev, [rowId]: "" }));
    }
    console.log(`Saving marks for row ${rowId}: ${marks[rowId]}`);
    if (isDoctorateProgram(app)) {
      console.log(`Saving proposal marks: ${proposalMarks[rowId]}, publication marks: ${publicationMarks[rowId]}`);
    }
    setEditingRow(null); // Exit editing mode
    fetchData();
  };
  
  const csvcolumns = [
    { Header: "Sr.No", accessor: "serial", align: "center" },
    { Header: "Application ID", accessor: "id", align: "left" },
    { Header: "Applicant Name", accessor: "name", align: "center" },
    { Header: "Father Name", accessor: "father_name", align: "center" },
    { Header: "Campaign", accessor: "campaign_name", align: "center" },
    { Header: "Gender", accessor: "gender", align: "left" },
    { Header: "DOB", accessor: "dob", align: "left" },
    { Header: "Religion", accessor: "religion", align: "left" },
    { Header: "Current Address", accessor: "current_address", align: "left" },
    {
      Header: "Permanent Address",
      accessor: "permanent_address",
      align: "left",
    },
    {
      Header: "Emergency Contact Name",
      accessor: "emergency_contact_name",
      align: "left",
    },
    {
      Header: "Emergency Contact No",
      accessor: "emergency_contact_no",
      align: "left",
    },
    { Header: "Applicant CNIC", accessor: "applicant_cnic", align: "left" },
    { Header: "Father CNIC", accessor: "father_cnic", align: "left" },
    { Header: "Nationality", accessor: "nationality", align: "left" },
  ];

  const csvrows =
    all_applications.length > 0
      ? all_applications.map((app, index) => {
        return {
          serial: index + 1,
          id: app.id,
          name: app.name,
          father_name: app.father_name,
          campaign_name: app.campaign_name,
          gender: app.gender,
          dob: app.dob,
          religion: app.religion,
          current_address: app.current_address,
          permanent_address: app.permanent_address,
          emergency_contact_name: app.emergency_contact_name,
          emergency_contact_no: app.emergency_contact_no,
          applicant_cnic: app.applicant_cnic,
          father_cnic: app.father_cnic,
          nationality: app.nationality,
        };
      })
      : [];

  const handleExportCSV = () => {
    const data = [
      csvcolumns.map((col) => col.Header),
      ...csvrows.map((row) => Object.values(row)),
    ];

    const csv = Papa.unparse(data);

    const blob = new Blob([csv], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "Applications.csv";

    link.click();
  };

  // GET Api calls
  const getAllCampaigns = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(BASE_URL + `/campaign/get_campaigns`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setAllCampaigns(data.campaigns);
      })
      .catch((error) => console.log(error));
  };

  const getAllCampuses = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(BASE_URL + `/campus/get_campuses`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setAllCampuses(data.campuses);
      })
      .catch((error) => console.log(error));
  };

  const getDepartmentsByCampus = async (campus_id) => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(
      BASE_URL + `/department/get_departments_by_campus/${campus_id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        setAllDepartments(data.departments);
      })
      .catch((error) => console.log(error));
  };

  const getDepartments = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(BASE_URL + `/department/get_departments`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setAllDepartments(data.departments);
      })
      .catch((error) => console.log(error));
  };

  const getDegreesByDepartments = async (department_id) => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(
      BASE_URL + `/degree/get_degrees_by_department/${department_id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        setAllDegrees(data.degrees);
      })
      .catch((error) => console.log(error));
  };
  const getQuotas = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(BASE_URL + `/quota/get_quotas`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setAllQuotas(data.quotas);
      })
      .catch((error) => console.log(error));
  };
  const getAllApplications = async () => {
    if(degree_id.length <= 0){
      toast.error("Please Select Program First");
      return;
    }
    let data = {
      campaign_id: campaign_id,
      campus_id: campus_id,
      department_id: department_id,
      degree_id: degree_id,
      quota_id: quota_id,
    };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    };
    await fetch(
      BASE_URL + `/application/get_application_for_test_entry`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if(data.applications){
        setAllApplications(data.applications);
        setOriginalApplications(data.applications);
        } else {
          toast.error(data.message);
        }
      })
      .catch((error) => console.log(error));
  };

  const handleCampus = (value) => {
    console.log("Campus", value);
    setCampusId(value);
    // Reset department and degree when campus changes
    setDepartmentId("");
    setDegreeId("");
    setAllDegrees([]);
    // Get departments for the selected campus
    getDepartmentsByCampus(value);
  };

  const handleDepartment = (value) => {
    console.log("Department", value);
    setDepartmentId(value);
    getDegreesByDepartments(value);
  };
  
  const handleDegree = (value) => {
    setDegreeId(value);
    getQuotas();
  };
  
  const handleQuota = (value) => {
    setQuotaId(value);
  };

  const handleCampaign = (value) => {
    setCampaignId(value);
  };

  const fetchData = () => {
    getAllApplications();
  };

  const resetExtraVoucherForm = () => {
    setExtraVoucherForm({
      due_date: "",
      fee: "1000",
      form_no: "",
      campaign_id: campaign_id || "",
      label: "Extra Test Voucher",
    });
    setExtraVoucherApplication(null);
    setExistingExtraVoucher(null);
    setExistingVoucherPrintData(null);
  };

  const handleOpenExtraVoucherModal = () => {
    resetExtraVoucherForm();
    setExtraVoucherModalOpen(true);
  };

  const handleCloseExtraVoucherModal = () => {
    setExtraVoucherModalOpen(false);
    setExtraVoucherApplication(null);
    setExistingExtraVoucher(null);
    setExistingVoucherPrintData(null);
  };

  const handleCloseVoucherPrintModal = () => {
    setVoucherPrintModal(false);
    setVoucherPrintData({});
  };

  const handleExtraVoucherFieldChange = (field, value) => {
    setExtraVoucherForm((prev) => ({
      ...prev,
      [field]: value,
    }));

    if (field === "form_no" || field === "campaign_id") {
      setExtraVoucherApplication(null);
      setExistingExtraVoucher(null);
      setExistingVoucherPrintData(null);
    }
  };

  const handleFetchApplicationDetails = async () => {
    if (!extraVoucherForm.form_no || !extraVoucherForm.campaign_id) {
      toast.error("Please enter form number and select campaign");
      return;
    }

    setFetchingApplicationDetails(true);
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        application_id: extraVoucherForm.form_no,
        campaign_id: extraVoucherForm.campaign_id,
      }),
    };

    try {
      const response = await fetch(
        `${BASE_URL}/fee_voucher/get_extra_test_voucher_application_details`,
        requestOptions
      );
      const data = await response.json();
      if (response.ok) {
        setExtraVoucherApplication(data.application || null);
        setExistingExtraVoucher(data.existing_voucher || null);
        setExistingVoucherPrintData(data.existing_voucher ? data.admission_voucher || null : null);
        if (data.existing_voucher?.label) {
          setExtraVoucherForm((prev) => ({
            ...prev,
            label: data.existing_voucher.label,
          }));
        }
        if (data.existing_voucher?.voucher_code) {
          toast.info(`Extra test voucher already generated. Voucher no: ${data.existing_voucher.voucher_code}`);
        } else {
          toast.success("Application details fetched successfully");
        }
      } else {
        setExtraVoucherApplication(data.application || null);
        setExistingExtraVoucher(data.existing_voucher || null);
        setExistingVoucherPrintData(data.existing_voucher ? data.admission_voucher || null : null);
        if (data.existing_voucher?.label) {
          setExtraVoucherForm((prev) => ({
            ...prev,
            label: data.existing_voucher.label,
          }));
        }
        if (data.existing_voucher?.voucher_code) {
          toast.info(`Extra test voucher already generated. Voucher no: ${data.existing_voucher.voucher_code}`);
        } else {
          toast.error(data.error || data.message || "Failed to fetch application details");
        }
      }
    } catch (error) {
      setExtraVoucherApplication(null);
      setExistingExtraVoucher(null);
      setExistingVoucherPrintData(null);
      toast.error("Failed to fetch application details");
    } finally {
      setFetchingApplicationDetails(false);
    }
  };

  const handleGenerateExtraVoucher = async () => {
    if (!extraVoucherForm.form_no || !extraVoucherForm.campaign_id || !extraVoucherForm.due_date) {
      toast.error("Campaign, form number, due date and fee are required");
      return;
    }

    setExtraVoucherSubmitting(true);
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        application_id: extraVoucherForm.form_no,
        campaign_id: extraVoucherForm.campaign_id,
        due_date: extraVoucherForm.due_date,
        amount: extraVoucherForm.fee,
        label: extraVoucherForm.label,
      }),
    };

    try {
      const response = await fetch(
        `${BASE_URL}/fee_voucher/generate_extra_test_voucher`,
        requestOptions
      );
      const data = await response.json();
      if (response.ok) {
        if (data.already_exists && data.existing_voucher?.voucher_code) {
          setExistingExtraVoucher(data.existing_voucher);
          setExistingVoucherPrintData(data.admission_voucher || null);
          toast.info(data.message || `Extra test voucher already generated. Voucher no: ${data.existing_voucher.voucher_code}`);
          return;
        }

        setVoucherPrintData(data.admission_voucher || {});
        setVoucherPrintModal(true);
        setExtraVoucherModalOpen(false);
        toast.success(data.message || "Extra test voucher generated successfully");
      } else {
        if (data.existing_voucher?.voucher_code) {
          setExistingExtraVoucher(data.existing_voucher);
          setExistingVoucherPrintData(data.admission_voucher || null);
          toast.info(data.message || `Extra test voucher already generated. Voucher no: ${data.existing_voucher.voucher_code}`);
        } else {
          toast.error(data.error || data.message || "Failed to generate voucher");
        }
      }
    } catch (error) {
      toast.error("Failed to generate voucher");
    } finally {
      setExtraVoucherSubmitting(false);
    }
  };

  const handlePrintExistingExtraVoucher = () => {
    if (!existingVoucherPrintData) {
      toast.error("Voucher print data not available");
      return;
    }
    setVoucherPrintData(existingVoucherPrintData);
    setVoucherPrintModal(true);
  };

  // Initial Renderings
  useEffect(() => {
    const fetchInitialData = async () => {
      const [campaignsRes, campusesRes] = await Promise.all([
        fetch(BASE_URL + `/campaign/get_campaigns`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }).then((res) => res.json()),
        fetch(BASE_URL + `/campus/get_campuses`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }).then((res) => res.json()),
      ]);
  
      const campaigns = campaignsRes.campaigns || [];
      const campuses = campusesRes.campuses || [];
  
      setAllCampaigns(campaigns);
      setAllCampuses(campuses);
  
      if (userDepartment && campaigns.length > 0 && campuses.length > 0) {
        const activeCampaign = campaigns.find((c) => c.status === 1) || campaigns[0];
        const firstCampus = campuses[0];
  
        setCampaignId(activeCampaign.id);
        setCampusId(firstCampus.id);
  
        const departmentsRes = await fetch(
          BASE_URL + `/department/get_departments_by_campus/${firstCampus.id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        ).then((res) => res.json());
  
        const departments = departmentsRes.departments || [];
        setAllDepartments(departments);
  
        if (departments.length > 0) {
          const firstDepartment = departments[0];
          setDepartmentId(firstDepartment.id);
  
          // Fetch degrees for preselected department
          const degreesRes = await fetch(
            BASE_URL + `/degree/get_degrees_by_department/${firstDepartment.id}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          ).then((res) => res.json());
  
          setAllDegrees(degreesRes.degrees || []);
        }
      }
    };
  
    fetchInitialData();
  
  }, []);
  

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Stack
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
              paddingRight={3}
            >
              <div className="col-md-3">
                <label htmlFor="filter_campaign_id">Campaign</label>
                <Select
                  inputId="filter_campaign_id"
                  classNamePrefix="select"
                  options={all_campaigns.map((camp) => ({
                    value: camp.id,
                    label: camp.name,
                  }))}
                  value={
                    all_campaigns
                      .map((camp) => ({ value: camp.id, label: camp.name }))
                      .find((option) => option.value === campaign_id) || null
                  }
                  onChange={(selected) => handleCampaign(selected ? selected.value : "")}
                  placeholder="Select Campaign"
                  menuPortalTarget={document.body}
                  styles={campaignSelectStyles}
                />
              </div>
              <div className="col-md-3">
                <label htmlFor="filter_campus_id">Campus</label>
                <Select
                  inputId="filter_campus_id"
                  classNamePrefix="select"
                  options={all_campuses.map((campus) => ({
                    value: campus.id,
                    label: campus.name,
                  }))}
                  value={
                    all_campuses
                      .map((campus) => ({ value: campus.id, label: campus.name }))
                      .find((option) => option.value === campus_id) || null
                  }
                  onChange={(selected) => handleCampus(selected ? selected.value : "")}
                  placeholder="Select Campus"
                />
              </div>
              <div className="col-md-3">
                <label htmlFor="filter_department_id">Department</label>
                <Select
                  inputId="filter_department_id"
                  classNamePrefix="select"
                  options={all_departments.map((dept) => ({
                    value: dept.id,
                    label: dept.name,
                  }))}
                  value={
                    all_departments
                      .map((dept) => ({ value: dept.id, label: dept.name }))
                      .find((option) => option.value === department_id) || null
                  }
                  onChange={(selected) => handleDepartment(selected ? selected.value : "")}
                  placeholder="Select Department"
                  isDisabled={!campus_id}
                />
              </div>
              <div className="col-md-3">
                <label htmlFor="filter_degree_id">Programs</label>
                <Select
                  inputId="filter_degree_id"
                  classNamePrefix="select"
                  options={all_degrees.map((degree) => ({
                    value: degree.id,
                    label: degree.name,
                  }))}
                  value={
                    all_degrees
                      .map((degree) => ({ value: degree.id, label: degree.name }))
                      .find((option) => option.value === degree_id) || null
                  }
                  onChange={(selected) => handleDegree(selected ? selected.value : "")}
                  placeholder="Select Program"
                  isDisabled={!department_id}
                />
              </div>
            </Stack>

            <Stack
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              className="mt-3"
              spacing={1}
            >
              <Button
                variant="contained"
                onClick={handleOpenExtraVoucherModal}
                style={primaryButtonStyle}
              >
                Generate Extra Test Voucher
              </Button>
              <Button
                variant="contained"
                endIcon={<SearchIcon className="add-icon" />}
                onClick={fetchData}
                className="add-full-button"
                style={primaryButtonStyle}
              >
                Get Applications
              </Button>
            </Stack>

            <Card className="mt-5 card1">
              <MDBox
                mx={0}
                mt={0}
                py={2}
                px={2}
                variant="gradient"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Stack
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="center"
                  spacing={1}
                  sx={{ width: "100%" }}
                >
                  <Stack sx={{ flexGrow: 1 }}>
                    <Paper component="form" className="search-paper">
                      <InputBase
                        sx={{ ml: 1, flex: 1, fontSize: "16px" }}
                        placeholder="Search"
                        inputProps={{ "aria-label": "search voucher" }}
                        value={searchKeyword}
                        onChange={handleSearchKeywordChange}
                      />
                      <SearchIcon className="search-icon" />
                    </Paper>
                  </Stack>
                  {/* <Button
                    variant="outlined"
                    endIcon={<DocumentScannerIcon className="add-icon" />}
                    onClick={() => {
                      handleExportCSV();
                    }}
                    className="add-full-button"
                  >
                    Export CSV
                  </Button> */}
                </Stack>
              </MDBox>
              <MDBox pt={3}>
                {all_applications && all_applications.length > 0 ? (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                ) : (
                  <div style={{ textAlign: "center" }}>
                    <img
                      src={nodata}
                      style={{
                        display: "block",
                        margin: "auto",
                        width: "20%",
                        height: "20%",
                      }}
                    />
                  </div>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Dialog
        open={extraVoucherModalOpen}
        onClose={handleCloseExtraVoucherModal}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Generate Extra Test Voucher</DialogTitle>
        <DialogContent>
          <Stack spacing={2} mt={1}>
            <div>
              <label htmlFor="extra_test_campaign_id">Campaign</label>
              <Select
                inputId="extra_test_campaign_id"
                classNamePrefix="select"
                options={all_campaigns.map((camp) => ({
                  value: camp.id,
                  label: camp.name,
                }))}
                value={
                  all_campaigns
                    .map((camp) => ({ value: camp.id, label: camp.name }))
                    .find((option) => option.value === extraVoucherForm.campaign_id) || null
                }
                onChange={(selected) =>
                  handleExtraVoucherFieldChange("campaign_id", selected ? selected.value : "")
                }
                placeholder="Select Campaign"
                menuPortalTarget={document.body}
                styles={campaignSelectStyles}
              />
            </div>
            <TextField
              label="Due Date"
              type="date"
              value={extraVoucherForm.due_date}
              onChange={(e) => handleExtraVoucherFieldChange("due_date", e.target.value)}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
            <TextField
              label="Fee"
              type="number"
              value={extraVoucherForm.fee}
              onChange={(e) => handleExtraVoucherFieldChange("fee", e.target.value)}
              inputProps={{ min: 1 }}
              fullWidth
            />
            <TextField
              label="Voucher Label"
              value={extraVoucherForm.label}
              onChange={(e) => handleExtraVoucherFieldChange("label", e.target.value)}
              placeholder="Extra Test Voucher"
              fullWidth
            />
            <Stack direction={{ xs: "column", sm: "row" }} spacing={1} alignItems="flex-start">
              <TextField
                label="Form No"
                value={extraVoucherForm.form_no}
                onChange={(e) => handleExtraVoucherFieldChange("form_no", e.target.value)}
                fullWidth
              />
              <Button
                variant="contained"
                onClick={handleFetchApplicationDetails}
                disabled={fetchingApplicationDetails}
                style={{
                  ...primaryButtonStyle,
                  minWidth: "150px",
                  height: "56px",
                }}
              >
                {fetchingApplicationDetails ? "Fetching..." : "Fetch Details"}
              </Button>
            </Stack>
            {existingExtraVoucher?.voucher_code && (
              <Box
                sx={{
                  border: "1px solid #f0ad4e",
                  borderRadius: 1,
                  p: 2,
                  backgroundColor: "#fff8e6",
                }}
              >
                <MDTypography variant="button" display="block" fontWeight="bold" color="warning">
                  Extra test voucher already generated
                </MDTypography>
                <MDTypography variant="button" display="block" mt={1}>
                  Voucher No: {existingExtraVoucher.voucher_code}
                </MDTypography>
              </Box>
            )}
            {extraVoucherApplication && (
              <Box
                sx={{
                  border: "1px solid #d9d9d9",
                  borderRadius: 1,
                  p: 2,
                  backgroundColor: "#fafafa",
                }}
              >
                <MDTypography variant="button" display="block">
                  Name: {extraVoucherApplication.name || "-"}
                </MDTypography>
                <MDTypography variant="button" display="block">
                  Father Name: {extraVoucherApplication.father_name || "-"}
                </MDTypography>
                <MDTypography variant="button" display="block">
                  CNIC: {extraVoucherApplication.cnic || "-"}
                </MDTypography>
                <MDTypography variant="button" display="block">
                  Contact: {extraVoucherApplication.contact || "-"}
                </MDTypography>
              </Box>
            )}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={handleCloseExtraVoucherModal}
            style={primaryButtonStyle}
          >
            Close
          </Button>
          {existingExtraVoucher?.voucher_code ? (
            <Button
              variant="contained"
              onClick={handlePrintExistingExtraVoucher}
              disabled={!existingVoucherPrintData}
              style={primaryButtonStyle}
            >
              Print Voucher
            </Button>
          ) : (
            <Button
              variant="contained"
              onClick={handleGenerateExtraVoucher}
              disabled={extraVoucherSubmitting}
              style={primaryButtonStyle}
            >
              {extraVoucherSubmitting ? "Generating..." : "Generate"}
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <VoucherDialog
        voucherModal={voucherPrintModal}
        handleCloseVoucherModal={handleCloseVoucherPrintModal}
        admissionVoucher={voucherPrintData}
      />
    </DashboardLayout>
  );
}

export default TestResultEntry;